import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useGetParticipationQuery } from "@api/ParticipationsApi.ts";
import Loader from "@components/Loader.tsx";
import { ElementNotFound } from "@components/errors/ElementNotFound.tsx";
import { ParticipationContext } from "@/contexts/ParticipationContext";
import { Stack } from "@mui/material";
import ModuleSummaryCard from "@components/modules/ModuleSummaryCard.tsx";
import type { ModuleRead } from "@/types/api/types.ts";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN, ROLE_USER } from "@/constants";

export const Route = createFileRoute("/_dashboard/participations/$uuid")({
  beforeLoad: (args) => {
    requireRole([ROLE_ADMIN, ROLE_USER])(args);
  },
  component: ParticipationRouteLayout,
});

function ParticipationRouteLayout() {
  const { uuid } = Route.useParams();
  const { data, isLoading } = useGetParticipationQuery(uuid);

  if (isLoading) return <Loader />;
  if (!data) return <ElementNotFound />;

  return (
    <ParticipationContext.Provider value={data}>
      <Stack spacing={2}>
        <ModuleSummaryCard module={data.module as ModuleRead} />
        <Outlet />
      </Stack>
    </ParticipationContext.Provider>
  );
}
